//import { ODPSParser } from '../Service/ODPSParser';
import ODPSAnalyzer from "../Service/ODPSAnalyzer";

import UIFetchService from "../Service/UIFetchService";
import { isEmpty, isNotEmpty, ifEmpty } from "../Service/Utils";

import { Base64 } from "js-base64";

import * as monaco from "monaco-editor/esm/vs/editor/editor.api.js";

import {
  Row,
  Col,
  Input,
  Tree,
  Button,
  Select,
  message,
  Divider,
  Popconfirm,
  Modal,
  Tooltip,
  Space,
  Popover,
  AutoComplete,
  Tag,
} from "antd";
import {
  DownOutlined,
  FolderOutlined,
  FileTextOutlined,
  TableOutlined,
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { getDirList } from "./TemplateListView/service";

const demoSql = `-----最外层的select字段会在模版提交后自动解析--------

-- where语句可以整体被#⁢{WHERE|名称}的形式替换，此时支持在右侧边栏
-- 图形化的编辑where过滤条件。
-- 
-- where语句支持添加固定参数作为后续取数模版中的筛选器，
-- 具体参数格式可参考右上角模版说明,请一定要按照参数格式填写，否则无法识别


------参考模版如下：

-- 最外层SELECT不支持*，如果有复杂表达式，需要用AS重命名
-- SELECT bcz_uid, register_day,identity,sex,city,province
-- FROM dw_user_d_user_profile
-- #⁢{WHERE|查询条件1};
`;

const inputKinds = [
  { key: "DATE_RANGE", title: "日期范围", only: true },
  { key: "AFTER_DATE", title: "在某日之后", only: true },
  { key: "BEFORE_DATE", title: "在某日之前", only: true },
  { key: "AT_DATE", title: "在某日", only: true },
  { key: "IDENTITY", title: "身份" },
  { key: "SEX", title: "性别" },
  { key: "CITY", title: "国内城市" },
  { key: "CITY_LEVEL", title: "国内城市等级" },
  { key: "PROVINCE", title: "国内省份" },
  { key: "DEVICE_KIND", title: "设备类型" },
  { key: "DEVICE_PRICE", title: "设备价格" },
  { key: "USER_GRADE", title: "年级" },
  { key: "AD_POSITION", title: "广告位" },
  { key: "FROM_GROUP", title: "导流项目组" },
  { key: "TO_GROUP", title: "承接团队" },
  { key: "TO_OBJECT", title: "承接对象" },
  { key: "AD_KIND", title: "广告类型" },
  { key: "BCZ_WORD_BOOK", title: "百词斩词书" },
  { key: "YES_OR_NO", title: '"是“/”否“' },
  { key: "OPTS", title: "自定义枚举" },
  { key: "INPUT", title: "输入框" },
  { key: "MULTI_INPUT", title: "多条件输入框" },
  { key: "LIKE_INPUT", title: "全文匹配输入框" },
  { key: "BCZ_STAFF_UID", title: "员工选择框" },
];

// -- #⁢{WHERE|查询条件1};

const conditionsMan = (
  <>
    <Row justify="center" style={{ margin: "0 0 7px 0" }}>
      <Col style={{ border: "2px dotted gray" }}>
        <span style={{ fontSize: 17, color: "gray" }}>未扫描到查询条件</span>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span>格式1：</span>
        <code style={{ color: "green" }}>{"#{WHERE|条件名称}"}</code>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span>将会被扫描到，作为查询条件，在右侧边栏可以编辑这个条件。</span>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span>'WHERE'必须全大写，条件名称可以用户自定义。</span>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span>
          {"#{WHERE}"}
          查询条件不需要在前面再加`WHERE`关键字(查询时会自动添加`WHERE`关键字)。
        </span>
      </Col>
    </Row>
    <Divider style={{ margin: "12px" }} />
    <Row style={{ color: "gray" }}>
      <Col>
        <span>格式2：</span>
        <code style={{ color: "green" }}>{"#{表达式@输入框|条件名称}"}</code>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span style={{ color: "red" }}>{"<不建议使用>"}</span>
        <span>可选的条件表达式，需要自行拼接到WHERE语句中。</span>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span>表达式必须是一个有效的SQL表达式。</span>
      </Col>
    </Row>
    <Divider style={{ margin: "12px" }} />
    <Row style={{ color: "gray" }}>
      <Col>
        <span>格式3：</span>
        <code style={{ color: "green" }}>{"${输入框|条件名称}"}</code>
      </Col>
    </Row>
    <Row style={{ color: "gray" }}>
      <Col>
        <span style={{ color: "red" }}>{"<不建议使用>"}</span>
        <span>必选的条件表达式，需要自行拼接到WHERE语句中。</span>
      </Col>
    </Row>
    <Divider style={{ margin: "12px" }} />
    <Row style={{ color: "gray" }}>
      <Col>
        <span>输入框说明(针对格式2、3)：</span>
      </Col>
    </Row>
    {inputKinds
      .filter((kind) => !kind.only)
      .map((kind) => (
        <Row key={kind.key}>
          <Col flex="40%">
            <code style={{ color: "#1890ff" }}>{kind.key}</code>
          </Col>
          <Col flex="auto">
            <code style={{ color: "#389e0d" }}>// {kind.title}</code>
          </Col>
        </Row>
      ))}
    <Row>
      <Col flex="40%">
        <code style={{ color: "#1890ff" }}>yyyy-MM-dd</code>
      </Col>
      <Col flex="auto">
        <code style={{ color: "#389e0d" }}>// 日期</code>
      </Col>
    </Row>
  </>
);

class TemplateConfigurationViewV2 extends React.Component {
  constructor() {
    super();
    this.state = {
      incoming: {
        syntax: "ODPS-SQL",
        projectName: "bcz_datap",
        conditions: [],
      },
      allHint: {},
      clientHeight: document.body.clientHeight,
    };
    this.schemaKeywords = {};
    this.condCache = {};
    this.dirty = true;
  }

  render() {
    return (
      <>
        <Row>
          <Col flex="300px">
            <LeftSider
              data={this.state.incoming}
              onChange={(incoming) => this.setState({ incoming })}
              onUpdateSchemas={(schemasTree) => {
                this.schemaKeywords = this.buildSchemasKeywords(schemasTree);
                this.dirty = true;
              }}
              clientHeight={this.state.clientHeight}
              onCallback={(fetchSchemasTree) =>
                (this.fetchSchemasTree = fetchSchemasTree)
              }
            />
          </Col>
          <Col
            flex={`${document.body.clientWidth - 765}px`}
            style={{ margin: "0 7px 0 7px" }}
          >
            <div
              id="side-template-editor"
              style={{
                textAlign: "left",
                border: "1px solid #d9d9d9",
              }}
            ></div>
            <Row style={{ margin: "7px 0 0 0" }}>
              <Col flex="auto"></Col>
              <Col>
                <Space>
                  <Button
                    size="small"
                    type="link"
                    style={{ fontSize: 12 }}
                    href="/querying_guide/dashboard"
                  >
                    放弃保存
                  </Button>
                  <Button
                    size="small"
                    type="primary"
                    style={{ fontSize: 12 }}
                    onClick={this.onSaveAll.bind(this)}
                  >
                    保存模版
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col flex="360px">
            <RightSider
              data={this.state.incoming}
              hint={this.state.allHint}
              onChange={(incoming) => this.setState({ incoming })}
              clientHeight={this.state.clientHeight}
            />
          </Col>
        </Row>
      </>
    );
  }

  async componentDidMount() {
    window.onresize = () => {
      //console.log('hit');
      this.setState({ clientHeight: document.body.clientHeight });
      this.editor.layout({
        width: document.body.clientWidth - 771,
        height: document.body.clientHeight - 120,
      });
    };

    let incoming = undefined;
    if (this.props.tmplId > 0) {
      incoming = await UIFetchService.get(
        `/api/v1/querying_guide/templates/${this.props.tmplId}`
      );
      if (incoming) {
        this.setState({ incoming });
        this.fetchSchemasTree("", incoming.syntax, incoming.projectName);
      }
    } else {
      this.fetchSchemasTree(
        "",
        this.state.incoming.syntax,
        this.state.incoming.projectName
      );
    }

    const domNode = document.getElementById("side-template-editor");
    const instance = monaco.editor.create(domNode, {
      value: incoming === undefined ? demoSql : incoming.sql,
      theme: "vs-light",
      fontSize: 13,
      language: "sql",
      minimap: { enabled: false },
      automaticLayout: false,
    });
    instance.onDidChangeModelContent((e) => {
      this.dirty = true;
    });
    this.editor = instance;

    setTimeout(() => window.onresize(), 100);
    window.onresize();

    this.timer1 = setInterval(() => {
      const sql = instance.getValue();
      this.updateWherePlaceholders(sql);
    }, 500);

    this.timer2 = setInterval(() => {
      const sql = instance.getValue();
      this.updateAutocompleteHint(sql);
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer2);
    clearInterval(this.timer1);
  }

  async onSaveAll() {
    const sql = this.editor.getValue();
    this.updateWherePlaceholders(sql);

    if (!this.checkAll()) {
      return;
    }

    let tmplId = undefined;
    if (this.state.incoming.id === undefined) {
      const params = { ...this.state.incoming };
      params.sql = Base64.encode(ifEmpty(this.editor.getValue(), ""));
      const rs = await UIFetchService.post(
        "/api/v1/querying_guide/templates/complete",
        params
      );
      if (!rs) {
        message.error("保存失败");
        return;
      }
      if (isNotEmpty(rs.message)) {
        message.error(`保存失败:${rs.message}`);
        return;
      }
      tmplId = rs.id;
    } else {
      const params = { ...this.state.incoming };
      params.sql = Base64.encode(ifEmpty(this.editor.getValue(), ""));
      const rs = await UIFetchService.method(
        "PATCH",
        `/api/v1/querying_guide/templates/${this.props.tmplId}`,
        params
      );
      if (!rs) {
        message.error("保存失败");
        return;
      }
      if (isNotEmpty(rs.message)) {
        message.error(`保存失败:${rs.message}`);
        return;
      }
      tmplId = this.props.tmplId;
    }

    Modal.confirm({
      title: "保存完成",
      content: "是否继续编辑维度和指标？",
      okText: "继续",
      cancelText: "退出",
      onOk: () =>
        (window.location = `/querying_guide/template/${tmplId}/using?editing=true`),
      onCancel: () => (window.location = "/querying_guide/dashboard"),
    });
  }

  checkAll() {
    const incoming = this.state.incoming;

    if (isEmpty(incoming.directoryId)) {
      message.error("文件夹不能为空");
      return false;
    }

    if (isEmpty(incoming.name)) {
      message.error("模版名不能为空");
      return false;
    }

    if (isEmpty(incoming.syntax)) {
      message.error("没有选择数据源");
      return false;
    }

    if (isEmpty(incoming.projectName)) {
      message.error("没有选择项目空间");
      return false;
    }

    for (const cd of incoming.conditions) {
      let i = 1;
      for (const stmt of cd.stmts) {
        if (isEmpty(stmt.name)) {
          message.error(`查询条件'${cd.name}' 第[${i}]个条件： 名字不能为空`);
          return false;
        }
        if (isEmpty(stmt.expr)) {
          message.error(`查询条件'${cd.name}' 第[${i}]个条件： 表达式不能为空`);
          return false;
        }
        if (isEmpty(stmt.kind)) {
          message.error(
            `查询条件'${cd.name}' 第[${i}]个条件： 没有选择输入框类型`
          );
          return false;
        }
        if (stmt.kind === "OPTS" && isEmpty(stmt.opts)) {
          message.error(
            `查询条件'${cd.name}' 第[${i}]个条件： 指定了自定义枚举，但没有枚举值`
          );
          return false;
        }
        i++;
      }
    }

    return true;
  }

  updateWherePlaceholders(sql) {
    const incomingConds = {};

    let pos = 0;
    while (true) {
      const beginPos = sql.indexOf("#{WHERE|", pos);
      if (beginPos < 0) {
        break;
      }
      const endPos = sql.indexOf("}", beginPos + 2);
      if (beginPos < 0) {
        break;
      }
      const ph = sql.substring(beginPos, endPos + 1);
      pos = endPos + 1;

      const rs = ph.match(/^#{WHERE\|(.+)}$/);
      if (rs === null) {
        continue;
      }
      const name = rs[1];

      if (name in incomingConds) {
        incomingConds[name].position.push({ beginPos, endPos });
      } else {
        incomingConds[name] = {
          raw: ph,
          position: [
            {
              beginPos,
              endPos,
            },
          ],
        };
      }
    }

    //console.log(incomingConds);
    const forAdd = [];
    const forDel = [];

    const origin = this.state.incoming.conditions;
    for (const key of Object.keys(incomingConds)) {
      const found = origin.find((cd) => cd.name === key);
      if (found === undefined) {
        forAdd.push(key);
      }
    }

    const originKeys = origin.map((cd) => cd.name);
    for (const key of originKeys) {
      if (incomingConds[key] === undefined) {
        forDel.push(key);
      }
    }

    if (forAdd.length === 0 && forDel.length === 0) {
      return;
    }
    //console.log(forAdd, forDel);
    this.setState(({ incoming }) => {
      for (const key of forAdd) {
        const cache = this.condCache[key];
        if (cache) {
          incoming.conditions.push(cache);
          delete this.condCache[key];
        } else {
          incoming.conditions.push({
            name: key,
            ...incomingConds[key],
            stmts: [],
            fixed: "",
          });
        }
      }

      for (const key of forDel) {
        const idx = incoming.conditions.findIndex((cd) => cd.name === key);
        if (idx >= 0) {
          const [cd] = incoming.conditions.splice(idx, 1);
          this.condCache[cd.name] = cd;
        }
      }

      //console.log(incoming.conditions);
      return { incoming };
    });
  }

  buildSchemasKeywords(schemasTree) {
    if (!schemasTree) {
      return;
    }
    const schemaKeywords = {};

    schemasTree.forEach((level) => {
      // origin.children.forEach(level => {
      //     this.buildLevelKeywords(level, schemaKeywords)
      // });
      this.buildLevelKeywords(level, schemaKeywords);
    });
    return schemaKeywords;
  }

  buildLevelKeywords(level, schemaKeywords) {
    if (level.key.endsWith("saved-files")) {
      return;
    }
    //console.log(level);
    for (let schema of level.children ? level.children : []) {
      schemaKeywords[schema.title] = {
        columns: schema.children.map((field) => field.value),
        comment: schema?.value?.comment,
      };
    }
  }

  updateAutocompleteHint(sql) {
    if (!this.dirty) {
      return;
    }

    const conds = this.state.incoming.conditions;
    const stub = "WHERE 1=1";
    //            #{WHERE|1}
    for (const cond of conds) {
      const delta = cond.raw.length - stub.length;
      const filling = stub.padEnd(delta + 1, " ");
      sql = sql.replace(cond.raw, filling);
    }
    let lines = sql.split("\n");
    if (lines.length <= 1) {
      lines = sql.split("\r\n");
    }
    //console.log(this.schemaKeywords);
    const allHint = {};
    const analyzer = new ODPSAnalyzer(sql, this.schemaKeywords);
    try {
      analyzer.analyze();
      for (const cond of conds) {
        const hintKeys = {};
        for (const offset of cond.position) {
          const pos = this.toLineNumberAndColumn(offset.beginPos, lines);
          //console.log(pos);
          if (!pos) {
            continue;
          }
          const hint = analyzer.contains(pos);
          console.log(hint);
          for (const key of Object.keys(hint.alias)) {
            hint.schemas[key].columns.forEach((col) => {
              hintKeys[`${key}.${col.name}`] = col.type;
            });
          }
          if (Object.keys(hint.alias).length === 0) {
            hint.columns.forEach((col) => {
              hintKeys[col.name] = col.type;
            });
          }
        }
        //console.log(hintKeys);
        allHint[cond.name] = Object.keys(hintKeys)
          .sort()
          .map((key) => {
            return { name: key, type: hintKeys[key] };
          });
      }
    } catch (e) {
      console.log(e);
    }
    this.dirty = false;
    this.setState({ allHint });
  }

  toLineNumberAndColumn(pos, lines) {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (pos >= line.length + 1) {
        pos -= line.length + 1;
      } else {
        return { lineNumber: i + 1, column: pos };
      }
    }
  }
}

// /api/v1/schema/projects
function LeftSider(props) {
  const [projects, setProjects] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const [extendedKeys, setExtendedKeys] = useState([]);
  const [schemasTree, setSchemasTree] = useState([]);

  const [folderList, setFolderList] = useState([]);

  useEffect(() => {
    getDirList().then((res) => {
      if (res && Array.isArray(res)) {
        setFolderList(res);
      }
    });
  }, []);

  useEffect(async () => {
    const rs = await UIFetchService.get("/api/v1/schema/projects");
    setProjects(rs);
    //fetchSchemasTree('', props.data.syntax, props.data.projectName);
  }, []);
  props.onCallback(fetchSchemasTree);

  function buildSchemasTree(schemasTree) {
    if (!schemasTree) {
      return [];
    }
    const getFolderColor = (key) => {
      switch (key) {
        case "saved-files":
          return "#faad14";
        default:
          return "#389e0d";
      }
    };

    return schemasTree.map((level) => {
      level.icon = (
        <FolderOutlined style={{ color: getFolderColor(level.key) }} />
      );
      level.selectable = false;
      level.children = level.children.map((schema) => {
        if (schema.key?.startsWith("file-")) {
          let color = "#1890ff";
          if (schema?.value?.syntax === "HOLO-SQL") {
            color = "#faad14";
          }
          schema.icon = <FileTextOutlined style={{ color: color }} />;
        } else {
          schema.icon = <TableOutlined style={{ color: "#389e0d" }} />;
        }
        return schema;
      });
      return level;
    });
  }

  function fetchSchemasTree(key, syntax, projectName) {
    if (isEmpty(syntax)) {
      syntax = props.data.syntax;
    }
    if (projectName === undefined) {
      projectName = props.data.projectName;
    }
    UIFetchService.get(
      `/api/v1/querying_guide/schemas/tree?key=${encodeURI(
        key
      )}&projectName=${projectName}`
    ).then((tree) => {
      const newTree = buildSchemasTree(tree);
      setSchemasTree(newTree);
      if (isNotEmpty(key)) {
        setExtendedKeys(buildExtendedKeys(tree));
      }
      props.onUpdateSchemas(newTree);
    });
  }

  function buildExtendedKeys(schemasTree) {
    if (!schemasTree) {
      return [];
    }
    const keys = schemasTree.map((node) => node.key);
    return keys;
  }

  const rowStyle = { margin: "0 0 7px 0" };
  return (
    <>
      <Row style={rowStyle}>
        <Col flex="100px">
          <span style={{ color: "red" }}>*</span>
          <span>文件夹</span>
        </Col>
        <Col flex="auto">
          <Select
            value={props.data.directoryId + ""}
            onChange={(val) => {
              props.onChange({ ...props.data, directoryId: val });
            }}
            size="small"
            style={{ width: "100%" }}
            placeholder="请选择文件夹"
          >
            {folderList.map((folder) => {
              return (
                <Select.Option key={folder.id + ""}>
                  {folder.name}
                </Select.Option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col flex="100px">
          <span style={{ color: "red" }}>*</span>
          <span>数据集名称：</span>
        </Col>
        <Col flex="auto">
          <Input
            value={props.data.name}
            onChange={({ target: { value } }) =>
              props.onChange({ ...props.data, name: value })
            }
            size="small"
            style={{ width: "100%" }}
            placeholder="请输入模版名称"
          />
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col flex="100px">
          <span style={{ color: "red" }}>*</span>
          <span>数据源：</span>
        </Col>
        <Col flex="auto">
          <Select
            value={props.data.syntax}
            onChange={(syntax) => {
              props.onChange({ ...props.data, syntax, projectName: undefined });
              setExtendedKeys([]);
              fetchSchemasTree(searchKey, syntax, "");
            }}
            size="small"
            style={{ width: "100%" }}
          >
            <Select.Option value="ODPS-SQL">Maxcompute</Select.Option>
            <Select.Option value="HOLO-SQL">Hologress</Select.Option>
          </Select>
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col flex="100px">
          <span style={{ color: "red" }}>*</span>
          <span>项目空间：</span>
        </Col>
        <Col flex="auto">
          <Select
            value={props.data.projectName}
            onChange={(projectName) => {
              props.onChange({ ...props.data, projectName });
              setExtendedKeys([]);
              fetchSchemasTree(searchKey, props.data.syntax, projectName);
            }}
            size="small"
            style={{ width: "100%" }}
            placeholder="选择一个项目空间"
          >
            {props.data.syntax === "HOLO-SQL"
              ? (projects.Hologres === undefined ? [] : projects.Hologres).map(
                  (name) => <Select.Option value={name}>{name}</Select.Option>
                )
              : (projects.ODPS === undefined ? [] : projects.ODPS).map(
                  (name) => <Select.Option value={name}>{name}</Select.Option>
                )}
          </Select>
        </Col>
      </Row>
      <Row style={rowStyle}>
        <Col flex="100%">
          <Input.Search
            value={searchKey}
            onChange={({ target: { value } }) => {
              setSearchKey(value);
              fetchSchemasTree(
                value,
                props.data.syntax,
                props.data.projectName
              );
            }}
            style={{ width: "100%" }}
            size="small"
            placeholder="按表名搜索"
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col flex="100%">
          <StorageTree
            schemasTree={schemasTree}
            extendedKeys={extendedKeys}
            onExtendedKeysChange={(keys) => setExtendedKeys(keys)}
            clientHeight={props.clientHeight}
          />
        </Col>
      </Row>
    </>
  );
}

function StorageTree(props) {
  return (
    <Tree
      style={{
        width: "300px",
        overflowX: "auto",
        height: props.clientHeight - 210,
        overflowY: "auto",
        wordBreak: "keep-all",
        whiteSpace: "nowrap",
        border: "1px solid #f0f0f0",
      }}
      //defaultExpandAll
      showIcon
      virtual
      switcherIcon={<DownOutlined />}
      treeData={props.schemasTree}
      expandedKeys={props.extendedKeys}
      onExpand={(keys) => props.onExtendedKeysChange(keys)}
      // onMouseEnter={this.onLeftSiderTreeMouseEnter.bind(this)}
      // onMouseLeave={() => this.setState({ leftSiderTreeHintVisible: false })}
      // onDoubleClick={this.onLeftSiderTreeDoubleClick.bind(this)}
      // onSelect={(_, { selected, node }) => {
      //     if (selected) {
      //         this.setState({ leftSiderSelectedNode: node });
      //     }
      // }}
      // onRightClick={({ node }) => this.setState({ leftSiderContextNode: node })}
    />
  );
}

function RightSider(props) {
  const [exprEditorModal, setExprEditorModal] = useState({});

  const conditions = props.data.conditions;

  function onNameChange(node, name, exclude) {
    const incoming = { ...props.data };
    for (const cd of incoming.conditions) {
      let i = 0;
      for (const stmt of cd.stmts) {
        if (cd.name === exclude.name && i === exclude.index) {
          i++;
          continue;
        }

        if (stmt.name === name) {
          node.kind = stmt.kind;
          node.opts = stmt.opts;
          node.required = stmt.required;
          break;
        }
        i++;
      }
    }
    node.name = name;
    props.onChange(incoming);
  }

  function onKindChange(node, kind, exclude) {
    const incoming = { ...props.data };
    for (const cd of incoming.conditions) {
      let i = 0;
      for (const stmt of cd.stmts) {
        if (cd.name === exclude.name && i === exclude.index) {
          i++;
          continue;
        }
        if (isEmpty(stmt.name)) {
          i++;
          continue;
        }

        if (stmt.name === node.name) {
          stmt.kind = kind;
          node.opts = stmt.opts;
        }
        i++;
      }
    }
    node.kind = kind;
    props.onChange(incoming);
  }

  function onRequiredChange(node, required, exclude) {
    const incoming = { ...props.data };
    for (const cd of incoming.conditions) {
      let i = 0;
      for (const stmt of cd.stmts) {
        if (cd.name === exclude.name && i === exclude.index) {
          i++;
          continue;
        }
        if (isEmpty(stmt.name)) {
          i++;
          continue;
        }

        if (stmt.name === node.name) {
          stmt.required = !required;
        }
        i++;
      }
    }
    node.required = !required;
    props.onChange(incoming);
  }

  console.log(conditions);
  return (
    <div
      style={{
        height: props.clientHeight - 100,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {conditions.length === 0 && conditionsMan}
      {conditions.map((cd, cdi) => {
        const hintOptions =
          props.hint[cd.name] === undefined
            ? []
            : props.hint[cd.name].map((h) => {
                if (isEmpty(h.type)) {
                  return {
                    label: <span style={{ fontSize: 12 }}>{h.name}</span>,
                    value: h.name,
                  };
                } else {
                  return {
                    label: (
                      <code style={{ fontSize: 12 }}>
                        {h.name}
                        <Tag style={{ margin: "0 0 0 7px", fontSize: 12 }}>
                          {h.type}
                        </Tag>
                      </code>
                    ),
                    value: h.name,
                  };
                }
              });
        return (
          <>
            <Row key={cd.name + "::1"} style={{ margin: "0 0 7px 0" }}>
              <Col flex="100%" style={{}}>
                <div
                  style={{
                    width: 5,
                    height: 20,
                    float: "left",
                    backgroundColor: "#1890ff",
                    margin: "0 7px 0 0",
                  }}
                >
                  {" "}
                </div>
                <span style={{ fontWeight: 500 }}>{cd.name}</span>
                <Popover
                  title="输入框说明"
                  content={
                    <>
                      <Row>
                        <Col>日期范围：</Col>
                        <Col>选择一个开始和一个结束日期，闭区间</Col>
                      </Row>
                      <Row>
                        <Col>输入框：</Col>
                        <Col>匹配单一的值，完全匹配</Col>
                      </Row>
                      <Row>
                        <Col>全文匹配输入框：</Col>
                        <Col>匹配单一的值，全文匹配</Col>
                      </Row>
                      <Row>
                        <Col>多条件输入框：</Col>
                        <Col>
                          {
                            "匹配多个值其中的任意n(n>0)个，多个值之间用逗号(,)分割"
                          }
                        </Col>
                      </Row>
                    </>
                  }
                >
                  <span style={{ margin: "0 0 0 7px" }}>
                    <InfoCircleOutlined />
                  </span>
                </Popover>
              </Col>
            </Row>
            <Row justify="center">
              <Col flex="30%">
                <span style={{ fontSize: 12, color: "gray" }}>名字</span>
              </Col>
              <Col flex="33%">
                <span style={{ fontSize: 12, color: "gray" }}>表达式</span>
              </Col>
              <Col flex="auto">
                <span style={{ fontSize: 12, color: "gray" }}>输入框</span>
              </Col>
            </Row>

            {cd.stmts.map((stmt, stmti) => (
              <>
                <Row style={{ margin: "0 0 3px 0" }}>
                  <Col flex="30%" style={{ margin: "0 0 0 0" }}>
                    <Input.Group compact>
                      <Tooltip title="切换必填/选填状态">
                        <Button
                          size="small"
                          style={{ width: 27 }}
                          // onClick={() => {
                          //     const incoming = { ...props.data };
                          //     stmt.required = !stmt.required;
                          //     props.onChange(incoming);
                          // }}
                          onClick={() =>
                            onRequiredChange(stmt, stmt.required, {
                              name: cd.name,
                              index: stmti,
                            })
                          }
                        >
                          {stmt.required ? (
                            <code style={{ fontSize: 12, color: "red" }}>
                              *
                            </code>
                          ) : (
                            " "
                          )}
                        </Button>
                      </Tooltip>
                      <Input
                        value={stmt.name}
                        size="small"
                        onChange={({ target: { value } }) =>
                          onNameChange(stmt, value, {
                            name: cd.name,
                            index: stmti,
                          })
                        }
                        style={{ fontSize: 12, width: "calc(100% - 27px)" }}
                      />
                    </Input.Group>
                  </Col>
                  <Col flex="33%" style={{ margin: "0 0 0 0" }}>
                    {isNotEmpty(stmt.expr) && stmt.expr.length >= 32 ? (
                      <Tooltip title="点击编辑表达式">
                        <Button
                          size="small"
                          style={{ width: "calc(100% - 3px)%" }}
                          onClick={() => {
                            const modal = { ...exprEditorModal };
                            modal.visible = true;
                            modal.expr = stmt.expr;
                            modal.stmti = stmti;
                            modal.cdi = cdi;
                            setExprEditorModal(modal);
                          }}
                        >
                          {stmt.expr.substring(0, 12)}...
                        </Button>
                      </Tooltip>
                    ) : (
                      <Input.Group compact>
                        <AutoComplete
                          value={stmt.expr}
                          size="small"
                          onChange={(value) => {
                            const incoming = { ...props.data };
                            stmt.expr = value;
                            props.onChange(incoming);
                          }}
                          dropdownMatchSelectWidth={220}
                          filterOption
                          options={hintOptions}
                          style={{ fontSize: 12, width: "calc(100% - 30px)" }}
                        />
                        <Button
                          size="small"
                          onClick={() => {
                            const modal = { ...exprEditorModal };
                            modal.visible = true;
                            modal.expr = stmt.expr;
                            modal.stmti = stmti;
                            modal.cdi = cdi;
                            setExprEditorModal(modal);
                          }}
                        >
                          ...
                        </Button>
                      </Input.Group>
                    )}
                  </Col>
                  <Col flex="auto">
                    <Select
                      value={stmt.kind}
                      onChange={(kind) =>
                        onKindChange(stmt, kind, {
                          name: cd.name,
                          index: stmti,
                        })
                      }
                      style={{ width: "100px" }}
                      size="small"
                    >
                      {inputKinds.map((ik) => (
                        <Select.Option value={ik.key}>
                          <span style={{ fontSize: 12 }}>{ik.title}</span>
                        </Select.Option>
                      ))}
                    </Select>
                    <Popconfirm
                      title="是否删除这个条件?"
                      onConfirm={() => {
                        const incoming = { ...props.data };
                        cd.stmts.splice(stmti, 1);
                        props.onChange(incoming);
                      }}
                    >
                      <Button
                        style={{ width: 18, height: 18 }}
                        icon={<DeleteOutlined />}
                        danger
                        type="link"
                        size="small"
                      />
                    </Popconfirm>
                  </Col>
                </Row>
                {stmt.kind === "OPTS" && (
                  <Row style={{ margin: "0 0 3px 0" }}>
                    <Col flex="91%">
                      <Input
                        value={stmt.opts}
                        onChange={({ target: { value } }) => {
                          const incoming = { ...props.data };
                          stmt.opts = value;
                          props.onChange(incoming);
                        }}
                        size="small"
                        style={{ fontSize: 12, width: "100%" }}
                        addonBefore={
                          <span style={{ fontSize: 12 }}>枚举值</span>
                        }
                        placeholder="请输入枚举值，用逗号(,)分割"
                      />
                    </Col>
                  </Row>
                )}
              </>
            ))}

            <Row>
              <Col flex="100%">
                <Button
                  type="link"
                  size="small"
                  icon={<PlusOutlined />}
                  style={{ width: "100%" }}
                  onClick={() => {
                    const incoming = { ...props.data };
                    incoming.conditions = [...props.data.conditions];
                    incoming.conditions[cdi].stmts.push({
                      expr: "",
                      name: "",
                      kind: "INPUT",
                      required: false,
                    });
                    props.onChange(incoming);
                  }}
                >
                  增加一个条件
                </Button>
              </Col>
            </Row>

            <Row>
              <Col flex="100%">
                <Input.TextArea
                  value={cd.fixed}
                  onChange={({ target: { value } }) => {
                    const incoming = { ...props.data };
                    cd.fixed = value;
                    props.onChange(incoming);
                  }}
                  style={{ width: "100%", minHeight: 70, fontSize: 12 }}
                  size="small"
                  placeholder="此处填写额外的WHERE查询条件，必须是一个表达式，将会与其他条件AND连接。"
                  rows={4}
                />
              </Col>
            </Row>
            <Divider style={{ margin: "7px" }} />
          </>
        );
      })}
      {exprEditorModal.visible && (
        <ExpressionEditorModal
          {...exprEditorModal}
          onOk={(cdi, stmti, expr) => {
            const incoming = { ...props.data };
            incoming.conditions[cdi].stmts[stmti].expr = expr;
            props.onChange(incoming);

            setExprEditorModal({ visible: false });
          }}
          onCancel={() => setExprEditorModal({ visible: false })}
        />
      )}
    </div>
  );
}

function ExpressionEditorModal(props) {
  const [editor, initEditor] = useState();

  useEffect(() => {
    const domNode = document.getElementById("stmt-expression-editor");
    const instance = monaco.editor.create(domNode, {
      value: props.expr,
      theme: "vs-light",
      fontSize: 13,
      language: "sql",
      minimap: { enabled: false },
      automaticLayout: true,
    });
    initEditor(instance);
    instance.layout({
      width: 500,
      height: 400,
    });

    return () => instance.dispose();
  }, []);

  return (
    <Modal
      visible={props.visible}
      width={700}
      maskClosable={false}
      title="编辑表达式"
      onOk={() => props.onOk(props.cdi, props.stmti, editor.getValue())}
      onCancel={props.onCancel}
    >
      <div
        id="stmt-expression-editor"
        style={{
          textAlign: "left",
          border: "1px solid #d9d9d9",
        }}
      ></div>
    </Modal>
  );
}

export default TemplateConfigurationViewV2;
